module.exports = __webpack_public_path__ + "static/media/IMG-2.471951e6.jpg";